import SDKConfigurationModel from "../../../Configurator/Models/SDKConfiguraitonModel";
import CustomGameHttps from "../../../Https/CustomGameHttps";
import ProfileModel from "../../Profile/Models/ProfileModel";
import Profile from "../../Profile/Profile";
import BracketGameFilters from "../Models/Filters/BracketGameFilters";
import BracketGamePredictionsFilters from "../Models/Filters/BracketGamePredictionsFilters";
import BracketGameRankingsFilters from "../Models/Filters/BracketGameRankingsFilters";
import BracketGamePredictionRequestBody from "../Models/Prediction/RequestBody/BracketGamePredictionRequestBody";
import BracketGameValidator from "../Validator/BracketGameValidator";

export default class BracketGameFacade {
  private https: CustomGameHttps = null;
  private validator: BracketGameValidator = null;
  private profile: Profile = null;

  constructor(config: SDKConfigurationModel) {
    this.https = new CustomGameHttps(config);
    this.profile = new Profile(config);
    this.validator = new BracketGameValidator(config.errorHandlingMode);
  }

  public getGames = async (
    filters: BracketGameFilters,
    disableCache: boolean
  ) => {
    if (filters) {
      filters = new BracketGameFilters(filters);
    }

    return await this.https.getBracketGames(filters, disableCache);
  };

  public getGameById = async (gameId: string, disableCache: boolean) => {
    return await this.https.getBracketGameById(gameId, disableCache);
  };

  public makePrediction = async (
    gameId: string,
    prediction: BracketGamePredictionRequestBody
  ) => {
    this.validator.validatePrediction(prediction);

    return await this.https.makeBracketGamePrediction(gameId, prediction);
  };

  public updatePrediction = async (
    gameId: string,
    predictionId: string,
    prediction: BracketGamePredictionRequestBody
  ) => {
    this.validator.validatePrediction(prediction);

    return await this.https.updateBracketGamePrediction(
      gameId,
      predictionId,
      prediction
    );
  };

  public getGamePredictionsForUser = async (
    gameId: string,
    profileId: string,
    filters: BracketGamePredictionsFilters,
    disableCache: boolean
  ) => {
    if (filters) {
      filters = new BracketGamePredictionsFilters(filters);
    }

    const data = await this.https.getBracketGamePredictionsForUser(
      gameId,
      profileId,
      filters,
      disableCache
    );

    let profileModel = null;

    try {
      profileModel = await this.profile.getById(profileId).getInfo();
    } catch (error) {
      console.error(error);
    }

    data.data.forEach((prediction) => {
      prediction.profileModel = profileModel;
    });

    return data;
  };

  public getGamePredictionById = async (
    gameId: string,
    predictionId: string,
    disableCache: boolean
  ) => {
    return await this.https.getBracketGamePredictionById(
      gameId,
      predictionId,
      disableCache
    );
  };

  public getRankings = async (
    gameId: string,
    filters: BracketGameRankingsFilters,
    disableCache: boolean
  ) => {
    if (filters) {
      filters = new BracketGameRankingsFilters(filters);
    }

    const response = await this.https.getBracketGameRankings(
      gameId,
      filters,
      disableCache
    );
    const profileIds = response.data.map((d) => d.profileId);
    let profiles: ProfileModel[] = [];

    if (profileIds.length > 0) {
      profiles = await this.profile.getByIds(profileIds);
      response.data = response.data.map((d) => {
        d.profileModel = profiles.find((p) => p.id === d.profileId) || null;

        return d;
      });
    }

    return response;
  };
}
